//      
                                                           

export default (result            )               => {
  const { combine, destination } = result;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/droppable/what-is-dragged-over-from-result.js